import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../service/managers/storage.service';
import { Users } from '../../../model/users';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  protected user: Users;

  constructor(private storageService: StorageService) {
    this.user = this.storageService.getUser();
  }

  ngOnInit() {
  }

}
